import { css } from '@emotion/react';
import { theme } from '../../theme/theme';

export const tableStyle = css`
  width: 100%;
  border-collapse: collapse;
  font-size: ${theme.fontSize.md}px;
  text-align: left;

  thead {
    background: ${theme.color.bg};
    color: ${theme.color.textMuted};
    border-bottom: 1px solid ${theme.color.border};
  }

  th {
    padding: ${theme.space.sm}px ${theme.space.md}px;
    font-weight: 500;
  }

  td {
    padding: ${theme.space.sm}px ${theme.space.md}px;
  }

  tbody tr:not(:first-of-type) {
    border-top: 1px solid ${theme.color.border};
  }
`;
